/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit HumanId/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import LegacyId from './LegacyId/index'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function HumanId({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/TopBar/HumanId"
  
}) {
let patientHumanReadableIdValueData = fromData.useDataValue({ viewPath,
context: 'patient',
path: 'human_readable_id',
})
let dtColorsNeutral700 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.700'
        })
  return (<React.Fragment
>
<div
  data-testid="HumanId.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 size="normal"
 color={dtColorsNeutral700}
 data="patient.human_readable_id"
 text={patientHumanReadableIdValueData}
/>
<LegacyId
  viewPath={`${viewPath}/LegacyId`}
/>
</div>
{children}
</React.Fragment>)
}